import {
  DispenserDetailResponse,
  LastEventsResponse,
} from '@/features/dispensers/services/schemas.ts';
import Grid from '@mui/material/Grid';
import { BasicInfoCard } from '@/features/dispensers/components/dispenser-detail/subcomponents/basic-info-card/BasicInfoCard.tsx';
import { PosInfoCard } from '@/features/dispensers/components/dispenser-detail/subcomponents/pos-info-card/PosInfoCard.tsx';
import { CollectorInfoCard } from '@/features/dispensers/components/dispenser-detail/subcomponents/collector-info-card/CollectorInfoCard.tsx';
import { NotesCard } from '@/features/dispensers/components/dispenser-detail/subcomponents/notes-card/NotesCard.tsx';
import { DispenserStatusCard } from '@/features/dispensers/components/dispenser-detail/subcomponents/dispenser-status-card/DispenserStatusCard.tsx';
import { LastEventsCard } from '@/features/dispensers/components/dispenser-detail/subcomponents/last-events-card/LastEventsCard.tsx';
import { getLastEvent } from '@/features/dispensers/utils/lastEvent.ts';

export interface DispenserDetailProps {
  dispenser: DispenserDetailResponse;
  lastEvents: LastEventsResponse;
}

export const DispenserDetail = ({ dispenser, lastEvents }: DispenserDetailProps) => {
  return (
    <Grid container spacing={2}>
      <Grid container size={{ xs: 12, lg: 8 }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <BasicInfoCard data={dispenser} />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <PosInfoCard data={dispenser.pos} />
        </Grid>
        <Grid size={12}>
          <CollectorInfoCard data={dispenser.collector} />
        </Grid>
        {dispenser.note && (
          <Grid size={12}>
            <NotesCard note={dispenser.note} />
          </Grid>
        )}
      </Grid>
      <Grid size={{ xs: 12, lg: 4 }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6, lg: 12 }}>
            <DispenserStatusCard data={dispenser} lastEvent={getLastEvent(lastEvents)} />
          </Grid>
          <Grid size={{ xs: 12, md: 6, lg: 12 }}>
            <LastEventsCard lastEvents={lastEvents} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
